"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bnToRlp = void 0;
var bytes_1 = require("./bytes");
/**
 * Convert value from BN to RLP (unpadded buffer)
 * @param value value to convert
 */
function bnToRlp(value) {
    // Using `bn.toArrayLike(Buffer)` instead of `bn.toBuffer()`
    // for compatibility with browserify and similar tools
    return bytes_1.unpadBuffer(value.toArrayLike(Buffer));
}
exports.bnToRlp = bnToRlp;
//# sourceMappingURL=types.js.map